/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { productsDisable } from "../../funcs/productsDisable.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DisableProductRequest$inboundSchema,
};

export const tool$productsDisable: ToolDefinition<typeof args> = {
  name: "products-disable",
  description: `Disable a product by ID.

The product will no longer be available, but will remain in the system for historical and reporting purposes.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await productsDisable(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
